import React from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import styles from './styles.module.css';

const BrowserSupportMsg = () => (
  <div className={`${styles.component} animate__animated animate__fadeIn`}>
    <Paper elevation={1}>
      <Typography variant="headline" component="h3">
        Unsupported browser
      </Typography>
      <Typography component="p">
        Please install the latest version of&nbsp;
        <a href="https://www.google.com/chrome/browser/desktop/" target="_blank" rel="noopener noreferrer">
          Chrome
        </a>
      </Typography>
    </Paper>
  </div>
);

function mapStateToProps(state) {
  return {
    configs: state.configs,
  };
}

export default connect(mapStateToProps)(BrowserSupportMsg);
